import { lazy, Suspense } from 'react';

// Only load the debug panel in development
const EnhancedDebugPanel = import.meta.env.DEV
  ? lazy(() => import('./enhanced-debug-panel').then((module) => ({ default: module.EnhancedDebugPanel })))
  : () => null;

export const ConditionalDebugPanel = () => {
  if (!import.meta.env.DEV) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <EnhancedDebugPanel />
    </Suspense>
  );
};
